'use client';

import { useState } from 'react';

export type ExpandableTextProps = {
  collapsed: string;
  expanded: string;
  isExpanded?: boolean;
};

export const ExpandableText = (props: ExpandableTextProps) => {
  const [isExpanded, setIsExpanded] = useState(props.isExpanded);
  return (
    <span
      style={isExpanded ? undefined : { cursor: 'pointer', textDecoration: 'underline' }}
      onClick={() => setIsExpanded(true)}
    >
      {isExpanded ? props.expanded : props.collapsed}
    </span>
  );
};
